export type MapNullable<I, O> = I extends null | undefined ? I : O;

export function mapNullable<I, O>(fn: (i: NonNullable<I>) => O, input: I): MapNullable<I, O> {
  if (input == null) return input as MapNullable<I, O>;
  return fn(input as NonNullable<I>) as MapNullable<I, O>;
}
